// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".settings--tabs[data-v-43166260] .tabs {\n    padding: 0px\n}", "",{"version":3,"sources":["/home/cjzhi98/chatwoot-saas/app/javascript/dashboard/routes/dashboard/branches/components/viewBranch.vue"],"names":[],"mappings":"AAGI;IAAA;AAAA","file":"viewBranch.vue","sourcesContent":["\n.settings--tabs {\n  ::v-deep .tabs {\n    @apply p-0;\n  }\n}\n"]}]);
// Exports
module.exports = exports;
